export default function getVideoThumbnail(videoSelector) {
  const canvas = document.createElement('canvas');
  const videoElement = document.querySelector(videoSelector);

  canvas.height = videoElement.videoHeight;
  canvas.width = videoElement.videoWidth;

  canvas.getContext('2d').
  drawImage(videoElement, 0, 0, videoElement.videoWidth, videoElement.videoHeight);

  const imageUrl = canvas.toDataURL();

  canvas.remove();

  return imageUrl;
}